
import { FaChevronRight } from "react-icons/fa6"
import ContainerLayout from "./containerlayout"
import { PropTypes } from 'prop-types';
import { useEffect, useState } from "react";
import { DecodeHtml } from "../../utils/decodeHtml";
import { Link } from "react-router-dom";

const Faq = ({ admission }) => {


    const header5 = admission?.header5

    const data = admission?.fAQHyperlink?.map(item => {
        return {
            title: item?.name,
            description: "Click here to go to the Faq Page",
            link:"/faq"
        }

    })

    // const data = [
    //     {
    //         title: "Info for International Students",
    //         description: "Click here to go to the International Office Page",
    //         link: ""
    //     },
    //     {
    //         title: "Digital Flexible Learning",
    //         description: "Click here to go to the Digital Flexible Learning page",
    //         link: ""
    //     },
    //     {
    //         title: "When is the due date for the Registration Fee payment?",
    //         description: "Kindly pay the Registration Fee two days earlier before your date of registration. This is to ensure your payment is reflected in our system.",
    //         link: ""
    //     },
    //     {
    //         title: "Go to FAQ Page for more",
    //         description: "Click here to go to the FAQ Page",
    //         link: ""
    //     },
    // ]

    return (
        <ContainerLayout>
            <h1 className="w-auto   text-4xl font-bold ">{header5}</h1>
            <div className="grid gap-8 w-full">
                {
                    data?.map((item, index) => {
                        return (
                            <Link to={item.link} key={index} className="py-4 flex w-full justify-between items-start border-b border-gray-200 rounded-md">
                                <div className="grid gap-2">
                                    <h3 className="text-xl font-bold">{item.title}</h3>
                                    <p className="text-[#071946B2] font-normal text-[1rem]">{item.description}</p>
                                </div>
                                <div>
                                    <FaChevronRight size={20} />
                                </div>
                            </Link>
                        )
                    })
                }
            </div>

        </ContainerLayout>
    )
}
Faq.propTypes = {
    admission: PropTypes.object
}
export default Faq